"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _idbReactUiElements = require("@identitybuilding/idb-react-ui-elements");
var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));
var _react = _interopRequireDefault(require("react"));
var _Translations = _interopRequireDefault(require("./translations/Translations"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var translation = new _Translations["default"]();

// Main component to render the row
var CMProw = /*#__PURE__*/function (_React$Component) {
  _inherits(CMProw, _React$Component);
  var _super = _createSuper(CMProw);
  function CMProw(props) {
    var _this;
    _classCallCheck(this, CMProw);
    _this = _super.call(this, props);
    _this.state = {};
    return _this;
  }
  _createClass(CMProw, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.doLoadMore();
      window.addEventListener("resize", function () {
        return _this2.doLoadMore();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;
      window.removeEventListener("resize", function () {
        return _this3.doLoadMore();
      });
    }

    // Depending on the height of the row
    // and the amount of cmp"s, we show, or don"t show
    // a "load more" button
  }, {
    key: "doLoadMore",
    value: function doLoadMore() {
      var _this4 = this;
      var value = this.props.value;
      var settings = {},
        id = document.getElementById("digital_display_".concat(this.props.type)),
        height = id.getElementsByClassName("ddRow_".concat(this.props.type))[0].scrollHeight;
      var item = document.getElementsByClassName("cmp_wrapper_".concat(this.props.type));
      var _loop = function _loop(_i) {
        setTimeout(function () {
          if (item[_i].offsetTop !== item[0].offsetTop) {
            settings.more = true;
            _i = item.length;
          } else {
            settings.more = false;
          }
        }, 500);
        i = _i;
      };
      for (var i = 0; i < item.length; i++) {
        _loop(i);
      }
      setTimeout(function () {
        // settings.more = height > 305 ? true : false
        settings.height = settings.loaded ? "max-content" : height;
        settings.loaded = value.loaded && value.loaded ? true : false;
        _this4.setState(_defineProperty({}, "".concat(_this4.props.type, "_settings"), settings));
      }, 500);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var _this$props = this.props,
        value = _this$props.value,
        lang = _this$props.lang,
        limit = _this$props.limit,
        type = _this$props.type;
      var settings = this.state["".concat(type, "_settings")];
      var button_text_goto = translation.getContent("go_".concat(type === "cn" ? "cn" : "pn"), lang);
      var button_style = {
        borderColor: type,
        size: "S",
        txtColor: type,
        type: "sub"
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "digital_display_".concat(type)
      }, /*#__PURE__*/_react["default"].createElement("h3", null, /*#__PURE__*/_react["default"].createElement("span", null, translation.getContent("recent_".concat(type === "cn" ? "magazines" : "promos"), lang)), this.props.url_catalogue || this.props.url_promonetwork ? /*#__PURE__*/_react["default"].createElement("a", {
        href: type === 'cn' ? this.props.url_catalogue : this.props.url_promonetwork,
        rel: "noopener noreferrer",
        target: "_blank"
      }, type === 'cn' ? translation.getContent("go_cn", lang) : translation.getContent("go_pn", lang), /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: "ArrowLongRight"
      }))
      // <a href={`https://www.catalogusnetwerk.be/${this.props.lang}/${this.props.name}/${this.props.id}`} rel="noopener noreferrer" target="_blank">
      //     {translation.getContent(`go_cn`, lang)}<Icon name="ArrowLongRight" />
      // </a>
      : /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.catalogusnetwerk.be/",
        rel: "noopener noreferrer",
        target: "_blank"
      }, type === 'cn' ? translation.getContent("go_cn", lang) : translation.getContent("go_pn", lang), /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: "ArrowLongRight"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "ddRow ddRow_".concat(this.props.type),
        style: {
          height: settings && settings.loaded ? settings.height : 290,
          justifyContent: value.data.length < 7 && "left"
        }
      }, value.data.slice(0, limit).map(function (_ref, index) {
        var from = _ref.from,
          pdf = _ref.pdf,
          thumbnail = _ref.thumbnail,
          title = _ref.title,
          to = _ref.to,
          type = _ref.type,
          url = _ref.url;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "cmp_wrapper_".concat(_this5.props.type),
          key: index
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: "mWrapper pn",
          target: "_blank",
          rel: "noopener noreferrer",
          href: url && url[6] === '/' ? url : "https://".concat(url),
          key: index
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "dd ".concat(type)
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: thumbnail,
          alt: title
        }), /*#__PURE__*/_react["default"].createElement("h4", null, title), /*#__PURE__*/_react["default"].createElement("div", {
          className: "ddOverlay"
        })), /*#__PURE__*/_react["default"].createElement("h5", {
          className: type
        }, from, " ", /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
          name: "Magazines"
        })), " ", to)));
      })), settings && settings.more && !settings.loaded ? /*#__PURE__*/_react["default"].createElement(_idbReactUiElements.Button, _extends({
        label: translation.getContent("load_more", lang),
        text: translation.getContent("load_more", lang),
        onClick: function onClick() {
          _this5.props.stateHandler(value.data, true), _this5.doLoadMore();
        }
      }, button_style)) : /*#__PURE__*/_react["default"].createElement("div", {
        id: "goToNetwork"
      }, /*#__PURE__*/_react["default"].createElement(_idbReactUiElements.Button, _extends({
        label: button_text_goto,
        text: button_text_goto,
        url: this.props.url
      }, button_style))));
    }
  }]);
  return CMProw;
}(_react["default"].Component);
exports["default"] = CMProw;